import Vue from 'vue';
import Vue2LeafletYandex from '@/components/Vue2LeafletYandex.vue';

Vue.component('l-yandex-tile-layer', Vue2LeafletYandex);
